import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=905d3414&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"
import style0 from "./Review.vue?vue&type=style&index=0&id=905d3414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905d3414",
  null
  
)

export default component.exports